import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import { Form, Button, Dropdown, Menu } from "antd";
import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import { observer, inject } from "mobx-react";
import { autorun, toJS } from "mobx";
import styles from "./index.module.less";
import { ModuleMap, ModuleValue } from "common/modules";
import _ from "lodash";

const FormItem = Form.Item;

function getTextFilter() {
	function TextFilter() {}

	TextFilter.prototype.init = function(params) {
		this.valueGetter = params.valueGetter;
		this.filterText = null;
		this.setupGui(params);
	};

	// not called by ag-Grid, just for us to help setup
	TextFilter.prototype.setupGui = function(params) {
		this.gui = document.createElement("div");
		this.gui.innerHTML =
			'<div style="padding: 4px;">' +
			'<div style="font-weight: bold;">Search for sites</div>' +
			'<div><input style="margin: 4px 0px 4px 0px;" type="text" id="filterText" placeholder="Site url..."/></div>' +
			'<div style="margin-top: 5px; width: 200px;">Enter the sites that you want to search for</div>' +
			"</div>";

		this.eFilterText = this.gui.querySelector("#filterText");
		this.eFilterText.addEventListener("changed", listener);
		this.eFilterText.addEventListener("paste", listener);
		this.eFilterText.addEventListener("input", listener);
		// IE doesn't fire changed for special keys (eg delete, backspace), so need to
		// listen for this further ones
		this.eFilterText.addEventListener("keydown", listener);
		this.eFilterText.addEventListener("keyup", listener);
		this.filterChangedCallback = params.filterChangedCallback;

		var that = this;

		function listener(event) {
			that.filterText = event.target.value;
			params.filterChangedCallback();
		}
	};

	TextFilter.prototype.getGui = function() {
		return this.gui;
	};

	TextFilter.prototype.doesFilterPass = function(params) {
		// make sure each word passes separately, ie search for firstname, lastname
		var passed = true;
		var valueGetter = this.valueGetter;
		var value = valueGetter(params);
		if (
			value
				.toString()
				.toLowerCase()
				.indexOf(this.filterText.toLowerCase()) < 0
		) {
			passed = false;
		}
		if (passed && this.filterText.toLowerCase() == "wordpress.com") {
			// console.log(params);
		}
		return passed;
	};

	TextFilter.prototype.isFilterActive = function() {
		var isActive =
			this.filterText !== null &&
			this.filterText !== undefined &&
			this.filterText !== "";
		return isActive;
	};

	TextFilter.prototype.getApi = function() {
		var that = this;
		return {
			getModel: function() {
				var model = { value: that.filterText.value };
				return model;
			},
			setModel: function(model) {
				that.eFilterText.value = model.value;
			}
		};
	};

	TextFilter.prototype.getModelAsString = function(model) {
		return model ? model : "";
	};

	TextFilter.prototype.getModel = function() {
		return this.filterText;
	};
	// lazy, the example doesn't use setModel()
	TextFilter.prototype.setModel = function(params) {
		if (!params) {
			this.filterText = "";
			this.eFilterText.value = "";
			this.filterChangedCallback();
		}
	};

	return TextFilter;
}

var doFollowRenderer = function(params) {
	if (params.node.group == true) {
		return null;
	}
	if (params.value == true) {
		return "<span>Yes</span>";
	} else {
		return "<span>No</span>";
	}
};

var siteStatusRenderer = function(params) {
	if (params.value == "SUCCESS") {
		return '<div class="ant-tag ant-tag-has-color" style="background-color: rgb(17, 119, 51);">Success</div>';
	} else if (params.value == "FAILED") {
		return '<div data-show="true" class="ant-tag ant-tag-has-color" style="background-color: rgb(217, 33, 32);">Failed</div>';
	} else if (params.value == "NONE") {
		return "";
	} else if (params.value == "RUNNING") {
		return '<div class="ant-tag ant-tag-has-color" style="background-color: rgb(16, 142, 233);">Running</div>';
	} else {
		return "<span></span>";
	}
};

var moduleFormatter = function(params) {
	return ModuleMap[params.value];
};

function strcmp(a, b) {
	return a < b ? -1 : a > b ? 1 : 0;
}

class SuccessFailureCount extends Component {
	render() {
		return (
			<Fragment>
				<FormItem>
					<span className={styles.status}>
						Success Sites: {this.props.successSiteCount}
					</span>
				</FormItem>
				<FormItem>
					<span className={styles.status}>
						Failed Sites: {this.props.failedSiteCount}
					</span>
				</FormItem>
			</Fragment>
		);
	}
}

@observer
export default class SiteList extends Component {
	constructor(props) {
		super(props);
		this.prevEditing = false;
		this.editing = false;

		this.oldSites = null;
		this.currentSites = null;
		this.disposer = null;
		this.successSiteCount = 0;
		this.failedSiteCount = 0;
		this.state = {
			selectedSiteCount: 0,
			showMode: "all"
		};
	}

	componentWillUnmount() {
		if (this.disposer != null) {
			this.disposer();
			this.updateSuccessFailureCount.cancel();
		}
	}

	updateSuccessFailureCount = _.debounce(() => {
		let successSiteCount = 0;
		let failedSiteCount = 0;

		this.gridApi.forEachNode(node => {
			if (node.group == false) {
				if (node.data.status == "SUCCESS") {
					successSiteCount++;
				}
			}
		});

		this.gridApi.forEachNode(node => {
			if (node.group == false) {
				if (node.data.status == "FAILED") {
					failedSiteCount++;
				}
			}
		});

		ReactDOM.render(
			<SuccessFailureCount
				successSiteCount={successSiteCount}
				failedSiteCount={failedSiteCount}
			/>,
			document.getElementById("successFailureContainer")
		);
	}, 200);

	onRowDataChanged = params => {
		let gridApi = params.api;				
		// this.setState({
		// 	selectedSiteCount: gridApi.getSelectedNodes().length
		// });
	};

	onGridReady(params) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		this.gridApi.sizeColumnsToFit();

		// console.log("On Grid Read");
		this.gridApi.forEachNode(node => {
			if (node.group == false) {
				node.setSelected(node.data.checked, false, false, false);
			}
		});

		let selectedSiteCount = this.props.sites.reduce((count, site) => {
			if (site.checked) {
				count++;
			}
			return count;
		}, 0);
		this.setState({
			selectedSiteCount: selectedSiteCount
		});

		this.disposer = autorun(() => {
			if (this.props.ui.updatedSite != null) {
				const row = this.props.ui.updatedSite;
				this.gridApi.batchUpdateRowData({
					update: [row]
				});

				this.updateSuccessFailureCount();

				// row.modulePlatform = ModuleMap[row.id.module] + ": " + row.platform;
			}
		});
		// if (this.props.expanded === true) {
		// 	this.gridApi.expandAll();
		// } else {
		// 	this.gridApi.collapseAll();
		// }
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (!this.gridApi) {
			return;
		}
		// if (prevProps.project.id != this.props.project.id) {
		//   this.gridApi.forEachNode(node => {
		//     if (node.group == false) {
		//       node.setSelected(node.data.checked, false, false, false);
		//     }
		//   });
		//   this.gridApi.setFilterModel(null);
		//   this.gridApi.onFilterChanged();
		//   return;
		// }
		// let checkedCount = 0;
		// for (var el of this.props.sites) {
		//   if (el.checked) {
		//     checkedCount++;
		//   }
		// }
		// console.log("Correct checked count is: " + checkedCount);

		if (this.prevEditing != this.editing) {
			// this.gridApi.forEachNode(node => {
			// 	if (node.group == false) {
			// 		node.setSelected(node.data.checked, false, false, false);
			// 	}
			// });
			for (var el of this.props.sites) {
				// const node = this.gridApi.getRowNode(el.id.module + "_" + el.siteId);
				const node = this.gridApi.getRowNode(
					this.props.getRowNodeId(el)
				);
				if (node != null) {
					node.setSelected(el.checked, false, false, false);
				}
			}
			this.gridApi.redrawRows();
			this.gridApi.refreshHeader();
			this.setState({
				selectedSiteCount: this.gridApi.getSelectedNodes().length
			});
			return;
		}
	}

	createGridDefs(columnDefs) {
		const gridDefs = {
			columnDefs: columnDefs,
			groupDefaultExpanded: -1,
			autoGroupColumnDef: {
				headerName: "Site",
				field: "id.siteId",
				filter: "agTextColumnFilter",
				headerCheckboxSelection: () => {
					return this.props.ui.editing;
				},
				headerCheckboxSelectionFilteredOnly: true,
				width: 300,
				editable: false,
				cellRenderer: "agGroupCellRenderer",
				cellRendererParams: {
					checkbox: true,
					readOnly: () => {
						return !this.props.ui.editing;
					}
				},
				// sort: "asc",
				suppressSorting: true
			},
			// defaultColDef: {
			// 	checkboxSelection: function(params) {
			// 		var isGrouping =
			// 			params.columnApi.getRowGroupColumns().length > 0;
			// 		return params.colIndex === 0 && !isGrouping;
			// 		// return false;
			// 	}
			// },
			rowSelection: "multiple"
		};
		return gridDefs;
	}
	// componentWillReceiveProps(nextProps) {
	// 	if (this.props.match.params.id != nextProps.match.params.id) {
	// 		this.props.dispatch({
	// 			type: "sites/create"
	// 		});
	// 	}
	// }

	componentDidMount() {
		// this.props.loadSites();
		// this.props.dispatch({
		// 	type: "sites/create"
		// });
	}

	// getRowData = () => {
	// 	return this.rowData;
	// };

	collapseAll = () => {
		this.gridApi.collapseAll();
	};

	expandAll = () => {
		this.gridApi.expandAll();
	};

	resetAllFilters = () => {
		this.setState({
			showMode: "all",
		}, () => {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		})		
	};

	onRowSelected = event => {
		if (event.node.group == false) {
			event.data.checked = event.node.selected;
		}
	};

	onSelectionChanged = event => {
		this.setState({
			selectedSiteCount: event.api.getSelectedNodes().length
		});
	};

	updateRow = row => {
		// row.modulePlatform = ModuleMap[row.id.module] + ": " + row.platform;
		this.gridApi.updateRowData({
			update: [row]
		});
	};

	getRowData = () => {
		if (this.gridApi == null) {
			return [];
		} else {
			let rowData = [];
			this.gridApi.forEachNode(node => {
				if (node.group == false) {
					rowData.push(node.data);
				}
			});
			return rowData;
		}
	};

	handleShowSitesMenuClick = ({key}) => {		
		this.setState({
			showMode: key
		}, () => {
			this.gridApi.onFilterChanged();
		});			
	}

	isExternalFilterPresent = () => {
		// if showMode is all, then we are not filtering		
		if (this.state.showMode === "all") {
			return false;
		}
		return true;
	}

	doesExternalFilterPass = (node) => {			
		switch (this.state.showMode) {
			case "selected": return node.data.checked == true;
			case "unselected": return node.data.checked == false;
			default: return true
		}		
	}

	render() {
		// console.log(this.props.sites);
		// var updatedSite = this.props.ui.updatedSite;
		this.prevEditing = this.editing;
		this.editing = this.props.ui.editing;
		// this.oldSites = this.currentSites;
		// this.currentSites = this.props.sites;
		// if (this.oldSites == this.currentSites) {
		// 	console.log("unchanged");
		// } else {
		// 	console.log("changed");
		// }
		// console.log("Site List rendered");
		if (this.props.sites.length == 0 && !this.props.showEmptyData) {
			return <div />;
		} else {
			// const gridDefs = this.state.gridDefs;
			const props = this.props;
			const gridDefs = this.createGridDefs(this.props.columnDefs);
			// this.rowData = toJS(this.props.sites);

			this.successSiteCount = this.props.sites.reduce((count, site) => {
				if (site.status == "SUCCESS") {
					count++;
				}
				return count;
			}, 0);

			this.failedSiteCount = this.props.sites.reduce((count, site) => {
				if (site.status == "FAILED") {
					count++;
				}
				return count;
			}, 0);

			let totalSiteCount = this.props.sites.length;
			// let selectedSiteCount = this.props.sites.reduce((count, site) => {
			// 	if (site.checked) {
			// 		count++;
			// 	}
			// 	return count;
			// }, 0);

			const showSitesMenu = (
				<Menu onClick={this.handleShowSitesMenuClick}>
					<Menu.Item key="all">All Sites</Menu.Item>
					<Menu.Item key="selected">
						Selected Sites
					</Menu.Item>
					<Menu.Item key="unselected">
						Unselected Sites
					</Menu.Item>
				</Menu>
			);

			return (
				<Fragment>
					<Form layout="inline">
						<FormItem>
							<Button
								type="primary"
								icon="minus"
								onClick={this.collapseAll}
							>
								Collapse
							</Button>
						</FormItem>
						<FormItem>
							<Button
								type="primary"
								icon="plus"
								onClick={this.expandAll}
							>
								Expand
							</Button>
						</FormItem>
						<FormItem>
							<Button
								type="primary"
								icon="filter"
								onClick={this.resetAllFilters}
							>
								Clear Filter
							</Button>
						</FormItem>
						<FormItem>
							<Dropdown overlay={showSitesMenu}>
								<Button type="primary">Show</Button>
							</Dropdown>
						</FormItem>
						<FormItem>
							<span className={styles.status}>
								Selected Sites: {this.state.selectedSiteCount}
							</span>
						</FormItem>
						<FormItem>
							<span className={styles.status}>
								Total Sites: {totalSiteCount}
							</span>
						</FormItem>
						<div
							id="successFailureContainer"
							style={{ display: "inline-block" }}
						>
							<SuccessFailureCount
								successSiteCount={this.successSiteCount}
								failedSiteCount={this.failedSiteCount}
							/>
						</div>
					</Form>
					{this.state.selectedSiteCount == 0 ? (
						<p style={{ color: "#f5222d" }}>
							You need to select at least one site
						</p>
					) : (
						<p></p>
					)}
					{/* <div id="successFailureContainer">
						<SuccessFailureCount
							successSiteCount={this.successSiteCount}
							failedSiteCount={this.failedSiteCount}
						/>
					</div> */}
					<div
						style={{
							boxSizing: "border-box",
							height: (window.screen.height * 3) / 4 - 80,
							width: "100%"
						}}
						className="ag-theme-balham"
					>
						<AgGridReact
							columnDefs={gridDefs.columnDefs}
							enableColResize={true}
							enableFilter={true}
							floatingFilter={true}
							enableSorting={true}
							groupSelectsChildren={true}
							groupSelectsFiltered={true}
							groupDefaultExpanded={gridDefs.groupDefaultExpanded}
							autoGroupColumnDef={gridDefs.autoGroupColumnDef}
							defaultColDef={gridDefs.defaultColDef}
							rowData={this.props.sites}
							enableRangeSelection={true}
							rowSelection={gridDefs.rowSelection}
							suppressRowClickSelection={true}
							onRowSelected={this.onRowSelected}
							onSelectionChanged={this.onSelectionChanged}
							isExternalFilterPresent={this.isExternalFilterPresent}
							doesExternalFilterPass={this.doesExternalFilterPass}
							// getRowNodeId={data => {
							// 	return data.id.module + "_" + data.siteId;
							// }}
							getRowNodeId={this.props.getRowNodeId}
							defaultGroupSortComparator={(nodeA, nodeB) => {
								var valueA = nodeA.key;
								var valueB = nodeB.key;
								if (ModuleValue[nodeA.key] != undefined) {
									valueA = ModuleValue[nodeA.key];
									valueB = ModuleValue[nodeB.key];
								}
								if (valueA === "Premium") {
									return -1;
								}
								if (valueB === "Premium") {
									return 1;
								}
								if (valueA < valueB) {
									return -1;
								} else if (valueA > valueB) {
									return 1;
								} else {
									return 0;
								}
							}}
							onSortChanged={e => {
								console.log(e.api.getSortModel());
							}}
							deltaRowDataMode={false}
							onGridReady={this.onGridReady.bind(this)}
							onRowDataChanged={this.onRowDataChanged.bind(this)}
						/>
					</div>
				</Fragment>
			);
		}
	}
}
